// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/entertainment.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/gaming.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/others.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/studies.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  line-height: 1.6;
  background-color: #f8f9fa;
}

/* Main content, making them all repeat and grid */
#task-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, 300px);
  justify-content: center;
  gap: 30px;
  padding: 40px;
  width: 100%;
  box-sizing: border-box;
  font-family: Arial, Helvetica, sans-serif;
}

#content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: 40px auto;
  font-family: Arial, Helvetica, sans-serif;
}

#content input[type='text'],
#content textarea,
#content select {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-family: inherit;
  box-sizing: border-box;
}

#categories {
  background-color: #97e099;
  color: white;
  font-weight: bold;
  border: none;
  padding: 12px 25px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
}

#categories:hover {
  background-color: #45a049;
}

/* How are the cards seen */
.task-card {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: transform 0.2s;
}

.task-card:hover {
  transform: translateY(-5px);
}

.task-card h3 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
}

.task-card p {
  color: #666;
  font-size: 0.9rem;
}

/* Style for priority */
.priority-task {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 800;
  text-transform: uppercase;
  margin-top: 10px;
  width: fit-content;
}

.urgent {
  background-color: #ff4d4d;
  color: white;
  box-shadow: 0 0 10px rgba(255, 77, 77, 0.4);
}

.normal {
  background-color: #e0e0e0;
  color: #333;
}

.interactive-btn {
  display: flex;
  justify-content: space-between;
}

/* Delete button style */
.delete-btn {
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
}

.edit-btn {
  background-color: #5c7cfa;
  color: white;
  border: none;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
}

.delete-btn:hover {
  background-color: #cc0000;
}

.edit-btn:hover {
  background-color: #516cd8;
}

.project-section {
  text-transform: capitalize;
}

.title-gaming {
  color: #2ecc71;
}

.task-gaming {
  background-color: #2ecc71;
}

.title-entertainment {
  color: #bb86fc;
}

.task-entertainment {
  background-color: #bb86fc;
}

.title-studies {
  color: #00d4ff;
}

.task-studies {
  background-color: #00d4ff;
}

.title-others {
  color: #d35400;
}

.task-others {
  background-color: #d35400;
}

.task-card {
  position: relative;
  border: 1px solid #ddd;
  padding: 20px;
  margin: 10px 0;
  border-radius: 8px;
  overflow: hidden;
  min-height: 100px;
}

.task-gaming::before,
.task-others::before,
.task-studies::before,
.task-entertainment::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.08;
  filter: grayscale(100%);
  pointer-events: none;
}

.task-entertainment::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.task-gaming::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.task-others::before::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.task-studies::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.task-card p {
  margin: 0;
  word-wrap: break-word;
  line-height: 1.5;
  color: #333;
}

.modal-overlay {
  /* Posicionamiento fijo para que cubra toda la pantalla */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  /* Color negro con opacidad (el "dim" de los juegos) */
  background-color: rgba(0, 0, 0, 0.6);

  /* Flexbox para centrar el formulario */
  display: none; /* Escondido por defecto */
  justify-content: center;
  align-items: center;

  z-index: 999;
}

.modal-overlay.active {
  display: flex;
}

.modal-overlay #task-form {
  background-color: white; /* O el color de tu interfaz */
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  width: 400px;
  border: 2px solid #444; /* Un toque más marcado */
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,8CAA8C;EAC9C,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,yDAAmD;AACrD;;AAEA;EACE,yDAA4C;AAC9C;;AAEA;EACE,yDAA4C;AAC9C;;AAEA;EACE,yDAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yDAAyD;EACzD,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;EAEZ,sDAAsD;EACtD,oCAAoC;;EAEpC,uCAAuC;EACvC,aAAa,EAAE,0BAA0B;EACzC,uBAAuB;EACvB,mBAAmB;;EAEnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB,EAAE,8BAA8B;EACvD,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,sBAAsB,EAAE,yBAAyB;AACnD","sourcesContent":["body {\r\n  line-height: 1.6;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n/* Main content, making them all repeat and grid */\r\n#task-content {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, 300px);\r\n  justify-content: center;\r\n  gap: 30px;\r\n  padding: 40px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n}\r\n\r\n#content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 15px;\r\n  padding: 30px;\r\n  background-color: #ffffff;\r\n  border-radius: 15px;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n  max-width: 500px;\r\n  margin: 40px auto;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n}\r\n\r\n#content input[type='text'],\r\n#content textarea,\r\n#content select {\r\n  width: 100%;\r\n  padding: 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-family: inherit;\r\n  box-sizing: border-box;\r\n}\r\n\r\n#categories {\r\n  background-color: #97e099;\r\n  color: white;\r\n  font-weight: bold;\r\n  border: none;\r\n  padding: 12px 25px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background 0.3s;\r\n  text-align: center;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n}\r\n\r\n#categories:hover {\r\n  background-color: #45a049;\r\n}\r\n\r\n/* How are the cards seen */\r\n.task-card {\r\n  background-color: #ffffff;\r\n  border-radius: 10px;\r\n  padding: 15px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.task-card:hover {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.task-card h3 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.task-card p {\r\n  color: #666;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Style for priority */\r\n.priority-task {\r\n  padding: 4px 12px;\r\n  border-radius: 20px;\r\n  font-size: 0.8rem;\r\n  font-weight: 800;\r\n  text-transform: uppercase;\r\n  margin-top: 10px;\r\n  width: fit-content;\r\n}\r\n\r\n.urgent {\r\n  background-color: #ff4d4d;\r\n  color: white;\r\n  box-shadow: 0 0 10px rgba(255, 77, 77, 0.4);\r\n}\r\n\r\n.normal {\r\n  background-color: #e0e0e0;\r\n  color: #333;\r\n}\r\n\r\n.interactive-btn {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n/* Delete button style */\r\n.delete-btn {\r\n  background-color: #ff4d4d;\r\n  color: white;\r\n  border: none;\r\n  padding: 8px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.edit-btn {\r\n  background-color: #5c7cfa;\r\n  color: white;\r\n  border: none;\r\n  padding: 8px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.delete-btn:hover {\r\n  background-color: #cc0000;\r\n}\r\n\r\n.edit-btn:hover {\r\n  background-color: #516cd8;\r\n}\r\n\r\n.project-section {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.title-gaming {\r\n  color: #2ecc71;\r\n}\r\n\r\n.task-gaming {\r\n  background-color: #2ecc71;\r\n}\r\n\r\n.title-entertainment {\r\n  color: #bb86fc;\r\n}\r\n\r\n.task-entertainment {\r\n  background-color: #bb86fc;\r\n}\r\n\r\n.title-studies {\r\n  color: #00d4ff;\r\n}\r\n\r\n.task-studies {\r\n  background-color: #00d4ff;\r\n}\r\n\r\n.title-others {\r\n  color: #d35400;\r\n}\r\n\r\n.task-others {\r\n  background-color: #d35400;\r\n}\r\n\r\n.task-card {\r\n  position: relative;\r\n  border: 1px solid #ddd;\r\n  padding: 20px;\r\n  margin: 10px 0;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  min-height: 100px;\r\n}\r\n\r\n.task-gaming::before,\r\n.task-others::before,\r\n.task-studies::before,\r\n.task-entertainment::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 100px;\r\n  height: 100px;\r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n  opacity: 0.08;\r\n  filter: grayscale(100%);\r\n  pointer-events: none;\r\n}\r\n\r\n.task-entertainment::before {\r\n  background-image: url('./assets/entertainment.png');\r\n}\r\n\r\n.task-gaming::before {\r\n  background-image: url('./assets/gaming.png');\r\n}\r\n\r\n.task-others::before::before {\r\n  background-image: url('./assets/others.png');\r\n}\r\n\r\n.task-studies::before {\r\n  background-image: url('./assets/studies.png');\r\n}\r\n\r\n.task-card p {\r\n  margin: 0;\r\n  word-wrap: break-word;\r\n  line-height: 1.5;\r\n  color: #333;\r\n}\r\n\r\n.modal-overlay {\r\n  /* Posicionamiento fijo para que cubra toda la pantalla */\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  /* Color negro con opacidad (el \"dim\" de los juegos) */\r\n  background-color: rgba(0, 0, 0, 0.6);\r\n\r\n  /* Flexbox para centrar el formulario */\r\n  display: none; /* Escondido por defecto */\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  z-index: 999;\r\n}\r\n\r\n.modal-overlay.active {\r\n  display: flex;\r\n}\r\n\r\n.modal-overlay #task-form {\r\n  background-color: white; /* O el color de tu interfaz */\r\n  padding: 30px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\r\n  width: 400px;\r\n  border: 2px solid #444; /* Un toque más marcado */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
